import { render, staticRenderFns } from "./component.vue?vue&type=template&id=c14b1ff2&scoped=true&"
import script from "./component.vue?vue&type=script&lang=js&"
export * from "./component.vue?vue&type=script&lang=js&"
import style0 from "./component.vue?vue&type=style&index=0&id=c14b1ff2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c14b1ff2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/projects/pes-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c14b1ff2')) {
      api.createRecord('c14b1ff2', component.options)
    } else {
      api.reload('c14b1ff2', component.options)
    }
    module.hot.accept("./component.vue?vue&type=template&id=c14b1ff2&scoped=true&", function () {
      api.rerender('c14b1ff2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/resource/component/submission-form/component.vue"
export default component.exports